<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1 3.175H2.9a2.15 2.15 0 0 0-2.15 2.15v15.4a2.15 2.15 0 0 0 2.15 2.15h18.2a2.15 2.15 0 0 0 2.15-2.15v-15.4a2.15 2.15 0 0 0-2.15-2.15Zm-18.2 1.5h18.2a.65.65 0 0 1 .65.65v15.4a.65.65 0 0 1-.65.65H2.9a.65.65 0 0 1-.65-.65v-15.4a.65.65 0 0 1 .65-.65Z"
      fill="currentColor"
    />
    <path
      d="M1.5 9.525h21M7.1 6.025v-4.9M16.9 6.025v-4.9"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
